'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_CategorySearch(text, mainOnly, pageIndex, pageSize, sort) {
  this.CX = null;
  this.CU = false;
  this.CV = 0;
  this.CW = 0;
  this.Lo = null;
  this.CX = text;
  this.CU = mainOnly;
  this.CV = pageIndex;
  this.CW = pageSize;
  this.Lo = sort;
}
export { $c_Lmealorama_CategorySearch as $c_Lmealorama_CategorySearch };
$p = $c_Lmealorama_CategorySearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_CategorySearch;
/** @constructor */
function $h_Lmealorama_CategorySearch() {
}
export { $h_Lmealorama_CategorySearch as $h_Lmealorama_CategorySearch };
$h_Lmealorama_CategorySearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 555394150);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.CX));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.CU ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.CV);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.CW);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Lo));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_CategorySearch)) {
    if (((((this.CU === x$0.CU) && (this.CV === x$0.CV)) && (this.CW === x$0.CW)) && (this.CX === x$0.CX))) {
      var x = this.Lo;
      var x$2 = x$0.Lo;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "CategorySearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.CX;
      break;
    }
    case 1: {
      return this.CU;
      break;
    }
    case 2: {
      return this.CV;
      break;
    }
    case 3: {
      return this.CW;
      break;
    }
    case 4: {
      return this.Lo;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_CategorySearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jp)));
}
export { $isArrayOf_Lmealorama_CategorySearch as $isArrayOf_Lmealorama_CategorySearch };
var $d_Lmealorama_CategorySearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_CategorySearch, "mealorama.CategorySearch", ({
  jp: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_CategorySearch as $d_Lmealorama_CategorySearch };
//# sourceMappingURL=mealorama.-Category-Search.js.map
